angular.module('autoremind.communications')
    .directive('communicationsTargetMissed', ['jobService', '$log', function (jobService, $log) {
        return {
            restrict: 'E',
            scope: true,
            templateUrl: 'app/communication/forms/communications-target-missed.html',
            link: function (scope) {
                // NOTE: scope.jobService is set on parent scope - NOT by injection into this directive
                // scope. = null;
                scope.firstTarget = scope.job.targets[0];
                scope.missedModel = {
                    selectedReasonId: null
                };
                scope.missedModel.targetsHasReasonAlready = function () {
                    for (var x in scope.job.targets) {
                        if (scope.job.targets[x].reasonId === scope.missedModel.selectedReasonId) {
                            return true; // Don't add the same reason twice
                        }
                    }
                    return false;
                };
                /**
                 * Add new target. Ensure that there is either one default (and only one reason) or if other reasons then no default.
                 * These visible targets are added after the first settings target that has no reasonId defined
                 */
                scope.missedModel.addToTargetGroup = function () {
                    if (!angular.isDefined(scope.missedModel.selectedReasonId) || scope.missedModel.selectedReasonId === 'undefined') {
                        return;
                    }
                    if (scope.missedModel.selectedReasonId === null) {
                        scope.job.targets.splice(1); // Delete all targets after first (settings) target
                    }
                    else {
                        // If first visible target (after settings target) is default then delete that before adding new target
                        if (scope.job.targets.length === 2 && scope.job.targets[1].reasonId === null) {
                            scope.job.targets.splice(1, 1); // Delete target with default reason
                        }
                    }
                    if (!scope.missedModel.targetsHasReasonAlready(scope.missedModel.selectedReasonId)) { // Don't add the same reason twice
                        var target = {
                            "type": "missed",
                            "reasonId": scope.missedModel.selectedReasonId,
                        };
                        scope.job.targets.push(target);
                    }
                    scope.job.updateTargets();
                };
                scope.updateTargets = function () {
                    // NOTE: This is probably not needed since it's updated on saving job
                    scope.job.targets[0].scanDaysBack = scope.job.jobContent.sendRulesLeft[3].daysAfterFirst;
                    scope.job.updateTargets();
                };
            }
        };
    }]);
//# sourceMappingURL=communications-target-missed.js.map